require('./stories');
require('./story');
require('./hero-autoplay');


// WEBPACK FOOTER //
// ./resources/js/modules/videos/index.js